import countries from '@/shared/catalogs/countries.json'
import departmentsGT from '@/shared/catalogs/departments-gt.json'
import municipalitiesGT from '@/shared/catalogs/municipalities-gt.json'
import type { VariableEnumValue } from '../core/types'

/**
 * Valores de enum para variables de ubicación (país/departamento/municipio).
 * El `value` = el NOMBRE (no el código), porque es lo que resuelven los orquestadores
 * (lookup en catálogo). Compartido entre lugar.* (negociación) y titular.* (cliente).
 */
const toEnumValues = (names: Array<string | undefined>): VariableEnumValue[] =>
  [...new Set(names.filter((n): n is string => Boolean(n)))]
    .sort((a, b) => a.localeCompare(b, 'es'))
    .map((n) => ({ value: n, label: n }))

export const PAIS_ENUM_VALUES = toEnumValues(countries.map((c) => c.name?.es))
export const DEPARTAMENTO_ENUM_VALUES = toEnumValues(departmentsGT.map((d) => d.name))
export const MUNICIPIO_ENUM_VALUES = toEnumValues(municipalitiesGT.map((m) => m.name))
